import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { CustomerState } from "@store/Store/Context/Customer/CustomerState";
import { Draft } from "immer";

const initialState: CustomerState = {
    rememberBillToShipTo: false,
};

export interface SetDefaultBillToShipToApiParameter extends ApiParameter {
    rememberBillToShipTo?: boolean;
}

const reducer = {
    "Store/Context/Customer/SetDefaultBillToShipTo": (
        draft: Draft<CustomerState>,
        action: { parameter: SetDefaultBillToShipToApiParameter },
    ) => {
        if (action.parameter.rememberBillToShipTo === true || action.parameter.rememberBillToShipTo === false) {
            draft.rememberBillToShipTo = action.parameter.rememberBillToShipTo;
        }
    },
};

const customerReducer = createTypedReducerWithImmer(initialState, reducer);
export default customerReducer;
